// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   TablePagination,
//   Chip,
//   Box,
//   Button,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";
// import { getAllAgentsService } from "../../services/agentService";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import useStore from "../../useStore";
// import CollectionsIcon from "@mui/icons-material/Collections";

// const statusColor = (status) => {
//   return status === "Active" ? "success" : "error";
// };

// const AgentTable = () => {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [agents, setAgents] = useState([]);
//   const [totalAgents, setTotalAgents] = useState();
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const { setEditUserId, setIsAgentUpdate } = useStore();

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const fetchAgents = async () => {
//     try {
//       const agents = await getAllAgentsService(page, rowsPerPage);
//       setAgents(agents?.agentsWithPhoneContacts); // Adjust this based on API response structure
//       setTotalAgents(agents?.totalAgents);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAgents();
//   }, [page, rowsPerPage]);

//   const handleViewClick = (agentId) => {
//     // Store the customer _id (you can use sessionStorage, localStorage, context, or state)
//     sessionStorage.setItem("viewedAgentId", agentId);

//     // Navigate to the customer detail page or handle as needed
//     navigate(`/agent/${agentId}`);
//   };
//   const handleEditClick = (agentId) => {
//     // Store the customer _id (you can use sessionStorage, localStorage, context, or state)
//     setEditUserId(agentId);
//     setIsAgentUpdate(true);
//     // Navigate to the customer detail page or handle as needed
//     navigate("/agent/create-agent");
//   };

//   return (
//     <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
//       <Box sx={{ display: "flex", justifyContent: "flex-end", m: 2 }}>
//         <Button
//           variant="contained"
//           size="small"
//           sx={{
//             py: 0.5,
//             textTransform: "capitalize",
//             fontSize: "16px",
//             borderRadius: "8px",
//           }}
//           onClick={() => {
//             navigate("create-agent"); // Relative path
//           }}
//         >
//           Create Agent
//         </Button>
//       </Box>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell sx={{ color: "#5252ff" }} align="center">
//               Sl. No.
//             </TableCell>
//             <TableCell sx={{ color: "#5252ff" }} align="center">
//               Agent code
//             </TableCell>
//             <TableCell sx={{ color: "#5252ff" }} align="center">
//               Agent Name
//             </TableCell>
//             <TableCell sx={{ color: "#5252ff" }} align="center">
//               Phone Number
//             </TableCell>
//             <TableCell sx={{ color: "#5252ff" }} align="center">
//               Created At
//             </TableCell>

//             <TableCell sx={{ color: "#5252ff" }} align="center">
//               Actions
//             </TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {agents.map((agent, index) => (
//             <TableRow key={agent._id}>
//               <TableCell sx={{ padding: "5px", margin: "0px" }} align="center">
//                 {page * rowsPerPage + index + 1}
//               </TableCell>
//               <TableCell sx={{ padding: "5px", margin: "0px" }} align="center">
//                 {agent.code}
//               </TableCell>
//               <TableCell sx={{ padding: "5px", margin: "0px" }} align="center">
//                 {agent.userName}
//               </TableCell>
//               <TableCell sx={{ padding: "5px", margin: "0px" }} align="center">
//                 {agent.contact?.contactValue || "N/A"}
//               </TableCell>
//               <TableCell sx={{ padding: "5px", margin: "0px" }} align="center">
//                 {moment(agent.createdAt).format("DD-MM-YYYY")}
//               </TableCell>

//               <TableCell sx={{ padding: "5px", margin: "0px" }} align="center">
//                 <IconButton
//                   color="primary"
//                   sx={{ padding: "5px", margin: "0px" }}
//                   onClick={() => handleEditClick(agent._id)}
//                 >
//                   <EditIcon />
//                 </IconButton>

//                 <IconButton
//                   color="default"
//                   sx={{ padding: "5px", margin: "0px" }}
//                   onClick={() => handleViewClick(agent._id)}
//                 >
//                   <VisibilityIcon />
//                 </IconButton>
//                 <IconButton
//                   color="default"
//                   sx={{ padding: "5px", margin: "0px" }}
//                   onClick={() => handleViewClick(agent._id)}
//                 >
//                   <CollectionsIcon />
//                 </IconButton>
//               </TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//       <TablePagination
//         rowsPerPageOptions={[10, 25]}
//         component="div"
//         count={totalAgents}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onPageChange={handleChangePage}
//         onRowsPerPageChange={handleChangeRowsPerPage}
//       />
//     </TableContainer>
//   );
// };

// export default AgentTable;
import React, { useCallback, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  Card,
  CircularProgress,
} from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  getAgentCollectionService,
  getAllAgentsService,
  getTodayCollectionService,
  searchAgentService,
} from "../../services/agentService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useStore from "../../useStore";
import CollectionsIcon from "@mui/icons-material/Collections";
import { toast } from "react-toastify";

const statusColor = (status) => {
  return status === "Active" ? "success" : "error";
};

const AgentTable = () => {
  const today = new Date().toISOString().split("T")[0];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [agents, setAgents] = useState([]);
  const [totalAgents, setTotalAgents] = useState();
  const [collectionId, setCollectionId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [collectionData, setCollectionData] = useState([]);
  const { setEditUserId, setIsAgentUpdate } = useStore();
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [data, setData] = useState([]);
  const [tclLoading, setTclLoading] = useState(false);
  const [loadingAgentId, setLoadingAgentId] = useState(null);

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleGenerateClick = async () => {
    setLoading(true);
    const getCollection = await getAgentCollectionService(
      collectionId,
      startDate,
      endDate
    );
    setCollectionData(getCollection?.agent_menus_list);
    setLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchAgents = useCallback(async () => {
    try {
      const agents = searchQuery
        ? await searchAgentService(page, rowsPerPage, searchQuery)
        : await getAllAgentsService(page, rowsPerPage);
      setAgents(agents?.agentsWithPhoneContacts); // Adjust this based on API response structure
      setTotalAgents(agents?.totalAgents);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }, [searchQuery, page, rowsPerPage]);

  useEffect(() => {
    fetchAgents();
  }, [page, rowsPerPage]);

  const handleSearchChange = useCallback((event) => {
    const query = event.target.value;
    setSearchQuery(query);

    // Reset to the first page when starting a new search
    setPage(0);
  }, []);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      fetchAgents();
    }, 500);

    return () => clearTimeout(debounceTimeout); // Cleanup timeout on unmount or re-render
  }, [fetchAgents]);

  const handleViewClick = (agentId) => {
    sessionStorage.setItem("viewedAgentId", agentId);
    navigate(`/agent/${agentId}`);
  };

  const handleEditClick = (agentId) => {
    setEditUserId(agentId);
    setIsAgentUpdate(true);
    navigate("/agent/create-agent");
  };

  const handleCollectionClick = async (agentId) => {
    setCollectionId(agentId);
    const getCollection = await getAgentCollectionService(
      agentId,
      startDate,
      endDate
    );
    setCollectionData(getCollection?.agent_menus_list);

    setIsModalOpen(true);
  };
  const handleTclClick = async (agentId, agentName) => {
    try {
      setLoadingAgentId(agentId);

      setCollectionId(agentId);
      const getCollection = await getTodayCollectionService(agentId);

      if (getCollection?.report_list?.length > 0) {
        exportToExcel(getCollection.report_list, agentName);
      } else {
        toast.warning("No data available to export.");
      }

      setLoadingAgentId(null);
    } catch (error) {
      console.error("Error fetching collection data:", error);
    }
  };
  const exportToExcel = (data, agentName) => {
    // Map the data for Excel formatting
    const formattedData = data.map((item) => ({
      "Collection Type": item.type,
      "Header Text": item.header_text,
      "Member Name": item.mem_name,
      "Phone Number": item.ph_num,
      "Due Date": item.due_date,
      Address: item.footer_text,
      "Due Amount": item.due_amount,
      "Payment Status": item.pay_status,
    }));

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Collections");

    // Create the filename with the agent's name and today's date
    const today = new Date().toISOString().split("T")[0];
    const fileName = `${agentName}_Collections_${today}.xlsx`;

    // Write and download the Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(dataBlob, fileName);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCollectionId(null);
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            m: 2,
            alignItems: "center",
          }}
        >
          <Box sx={{ width: "50%" }}>
            <Typography variant="h6" gutterBottom>
              Search Agents
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Search by name or phone number"
              onChange={handleSearchChange}
              value={searchQuery}
            />
          </Box>
          <Button
            variant="contained"
            size="small"
            sx={{
              py: 0.5,
              textTransform: "capitalize",
              fontSize: "16px",
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsAgentUpdate(false);
              navigate("create-agent");
            }}
          >
            Create Agent
          </Button>
        </Box>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: "#5252ff" }} align="center">
                Sl. No.
              </TableCell>
              <TableCell sx={{ color: "#5252ff" }} align="center">
                Agent Code
              </TableCell>
              <TableCell sx={{ color: "#5252ff" }} align="center">
                Agent Name
              </TableCell>
              <TableCell sx={{ color: "#5252ff" }} align="center">
                Phone Number
              </TableCell>
              <TableCell sx={{ color: "#5252ff" }} align="center">
                Created At
              </TableCell>
              <TableCell sx={{ color: "#5252ff" }} align="center">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {agents?.map((agent, index) => (
              <TableRow key={agent._id}>
                <TableCell align="center">
                  {page * rowsPerPage + index + 1}
                </TableCell>
                <TableCell
                  sx={{ padding: "5px", margin: "0px" }}
                  align="center"
                >
                  {agent.code}
                </TableCell>
                <TableCell
                  sx={{ padding: "5px", margin: "0px" }}
                  align="center"
                >
                  {agent.userName}
                </TableCell>
                <TableCell
                  sx={{ padding: "5px", margin: "0px" }}
                  align="center"
                >
                  {agent.contact?.contactValue || "N/A"}
                </TableCell>
                <TableCell align="center">
                  {moment(agent.createdAt).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell
                  sx={{ padding: "5px", margin: "0px" }}
                  align="center"
                >
                  <IconButton
                    color="primary"
                    onClick={() => handleEditClick(agent._id)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="default"
                    onClick={() => handleViewClick(agent._id)}
                  >
                    <VisibilityIcon />
                  </IconButton>
                  <IconButton
                    color="default"
                    onClick={() => handleCollectionClick(agent._id)}
                  >
                    <CollectionsIcon />
                  </IconButton>
                  <Button
                    variant="contained"
                    onClick={() => handleTclClick(agent._id, agent.userName)}
                  >
                    {loadingAgentId === agent._id ? (
                      <CircularProgress size={24} style={{ color: "#fff" }} />
                    ) : (
                      "TCL"
                    )}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25]}
          component="div"
          count={totalAgents}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: "12px",
            width: 800,
            border: "2px solid #5252ff",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              mb: 1,
              color: "#5252ff",
            }}
          >
            Collections
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              textAlign: "center",
              mb: 2,
              fontStyle: "italic",
              color: "#333",
            }}
          >
            Agent Name:{" "}
            <span style={{ fontWeight: "bold" }}>
              {agents.find((agent) => agent._id === collectionId)?.userName ||
                "N/A"}
            </span>
          </Typography>

          {/* Start Date & End Date */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              m: 1,
            }}
          >
            <TextField
              type="date"
              size="small"
              value={startDate}
              onChange={handleStartDateChange}
              sx={{ background: "#fff", borderRadius: "8px" }}
            />
            <TextField
              type="date"
              size="small"
              value={endDate}
              onChange={handleEndDateChange}
              sx={{ background: "#fff", borderRadius: "8px" }}
            />
            <Button
              variant="contained"
              size="small"
              onClick={handleGenerateClick}
              sx={{
                py: 0.5,
                textTransform: "capitalize",
                fontSize: "16px",
                borderRadius: "8px",
              }}
            >
              {loading ? (
                <CircularProgress size={24} style={{ color: "#fff" }} />
              ) : (
                "Generate"
              )}
            </Button>
          </Box>

          {/* Collection Data Display */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
              gap: 2,
            }}
          >
            {collectionData?.map((menu, index) => (
              <Card
                key={index}
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 3,
                  borderRadius: "8px",
                  backgroundColor: "#f5f5f5",
                  minHeight: 80,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", color: "#5252ff" }}
                >
                  {menu.menu_title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {index >= 6 ? ( // Add ₹ symbol only for collection values
                    <>
                      <span
                        style={{
                          fontSize: "1.2rem",
                          marginRight: "4px",
                          color: "#5252ff",
                        }}
                      >
                        ₹
                      </span>
                      {menu.menu_subtile}
                    </>
                  ) : (
                    menu.menu_subtile
                  )}
                </Typography>
              </Card>
            ))}
          </Box>

          {/* Close Button */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#5252ff",
                color: "white",
                textTransform: "capitalize",
                fontWeight: "bold",
                px: 4,
                borderRadius: "8px",
                "&:hover": { backgroundColor: "#3b3bb3" },
              }}
              onClick={handleCloseModal}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AgentTable;
